import { useQuery } from '@tanstack/react-query';
import { candidateRequestCount } from '../api/candidateRequests';
import { usePermission } from '../auth/usePermission';

export const requestsQueryKey = (type) => [`${type}-requests`];
export const requestsCountQueryKey = (type) => [`${type}-requests`, 'count'];

/** Pending count of a single-candidate request type, for the sidebar badge (polled). */
export function useCandidateRequestCount(type) {
  const { can } = usePermission();
  const enabled = can(`${type}-requests.approve`);

  const query = useQuery({
    queryKey: requestsCountQueryKey(type),
    queryFn: () => candidateRequestCount(type),
    enabled,
    refetchInterval: 60_000,
  });

  return enabled ? (query.data ?? 0) : 0;
}
